import React, { useMemo } from 'react';
import {
  ActivityIndicator,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  type StyleProp,
  type ViewStyle,
} from 'react-native';
import Ionicons from '@react-native-vector-icons/ionicons/static';
import { GTFonts, useTheme, type Theme } from '../../theme';
import { fs, s } from '../../utils/libs';

type IoniconsName = React.ComponentProps<typeof Ionicons>['name'];

type Props = {
  amount?: number;
  label: string;
  onPress?: () => void;
  disabled?: boolean;
  loading?: boolean;
  icon?: IoniconsName;
  style?: StyleProp<ViewStyle>;
};

const GreenActionButton: React.FC<Props> = ({
  amount = 0,
  label,
  onPress,
  disabled,
  loading,
  icon,
  style,
}) => {
  const { theme } = useTheme();
  const isWeb =Platform.OS === 'web';
  const styles = useMemo(() => createStyles(theme,isWeb), [theme,isWeb]);
  const isDisabled = !!disabled || !!loading;
  
  return (
    loading && amount > 0 ? null : <TouchableOpacity
      style={[
        styles.button,
        style,
        isDisabled && !loading && styles.buttonDisabled,
      ]}
      onPress={isDisabled ? undefined : onPress}
      disabled={isDisabled}
      activeOpacity={0.85}>
      <>
        {icon ? (
          <Ionicons name={icon} size={fs(18)} color="#fff" />
        ) : null}
        <Text style={styles.label}>{label}</Text>
      </>
    </TouchableOpacity>
  );
};

const createStyles = (theme: Theme,isWeb:boolean) =>
  StyleSheet.create({
    button: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: s(6),
      backgroundColor: theme.colors.successDark,
      paddingHorizontal: isWeb ? s(8) : s(12),
      paddingVertical: isWeb ? s(6) : s(8),
      borderRadius: theme.borderRadius.md,
    },
    buttonDisabled: {
      opacity: 0.55,
    },
    label: {
      color: '#fff',
      fontFamily: GTFonts.semibold,
      fontSize: fs(14),
      lineHeight: fs(20),
    },
  });

export default GreenActionButton;
